// i18next prints a locize advertisement by default in the console.
// We monkey-patch console to suppress it globally in the app before importing i18next.
const originalLog = console.log;
const originalWarn = console.warn;
const originalInfo = console.info;

console.log = (...args: unknown[]) => {
  if (typeof args[0] === "string" && args[0].includes("locize")) return;
  originalLog(...args);
};

console.warn = (...args: unknown[]) => {
  if (typeof args[0] === "string" && args[0].includes("locize")) return;
  originalWarn(...args);
};

console.info = (...args: unknown[]) => {
  if (typeof args[0] === "string" && args[0].includes("locize")) return;
  originalInfo(...args);
};

import { resources } from "@yalana/contracts";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { config as zodConfig } from "zod";

export const i18nReady = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: "common",
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes interpolated values; keep false to avoid double-escaping
    },
    resources,
  });

zodConfig({
  customError: (issue) => {
    if (issue.code === "too_small") {
      return { message: i18n.t("common.required") };
    }
    if (issue.code === "invalid_format") {
      return { message: i18n.t("common.invalidFormat") };
    }
  },
});

export default i18n;
